<script setup lang="ts">
  const props = defineProps({
    height: {
      type: String,
      default: '4'
    },
    width: {
      type: String,
      default: '100%'
    },
    class: {
      type: String,
      default: ''
    }
  })

  const computedClasses = computed(() => {
    return `h-${props.height} w-[${props.width}] mb-3 ${props.class}`
  })
</script>

<template>
  <USkeleton
    :class="computedClasses"
    class="animate-pulse rounded-md bg-[#303338] dark:bg-[#303338]"
  />
</template>
